<template>
  <component v-if="comp" :is="comp" v-bind="$attrs" />
  <slot v-else-if="renderSlot" />
</template>

<script setup>
import { whiteLabelRegistry } from "./registry";
import { shallowRef, onMounted, onUnmounted, ref } from "vue";
defineOptions({ inheritAttrs: false });

const props = defineProps({
  componentName: String,
});

const comp = shallowRef(null);
const renderSlot = ref(false);

onMounted(async () => {
  const name = props.componentName;

  if (!name) {
    renderSlot.value = true;
    return;
  }

  try {
    const component = await whiteLabelRegistry.loadComponent(name);

    if (component) {
      comp.value = component;
    } else {
      renderSlot.value = true;
    }
  } catch (error) {
    renderSlot.value = true;
  }
});

onUnmounted(() => {
  comp.value = null;
});
</script>
